import {getAxiosInstance, rethrowErrorWithMessage} from '../helpers/axios-helper'

const baseUrl = process.env.BACKEND_URL
console.log(' > baseUrl:', baseUrl)

function getIntroTexts() {
  console.log('calling intro texts service')
  return getAxiosInstance().get(`${baseUrl}/introTexts`)
    .then(introTextsResult => {
      return introTextsResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function getIntroTextById(introTextId) {
  return getAxiosInstance().get(`${baseUrl}/introTexts/${introTextId}`)
    .then(introTextsResult => {
      return introTextsResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function createIntroText(introText) {
  return getAxiosInstance().post(`${baseUrl}/introTexts`, {
    introText
  })
    .then(introTextsResult => {
      console.log('IntroText created')
      return {
        isSuccess: true,
        data: introTextsResult.data
      }
    })
    .catch(err => {
      console.log(err)
      return {
        isSuccess: false,
        errors: ['Unable to create this Intro']
      }
    })
}

function updateIntroText(introText) {
  const introTextId = introText.introTextId

  return getAxiosInstance().put(`${baseUrl}/introTexts/${introTextId}`, {
    introText
  })
    .then(introTextsResult => {
      console.log('IntroText updated')
      return {
        isSuccess: true,
        data: introTextsResult.data
      }
    })
    .catch(err => {
      console.log(err)
      return {
        isSuccess: false,
        errors: ['Unable to update this Intro']
      }
    })
}

function deleteIntroText(introTextId) {
  return getAxiosInstance().delete(`${baseUrl}/introTexts/${introTextId}`)
    .then((data) => data)
    .catch(err => {
      if (err.response.status === 403) {
        throw new Error(err.response.data.message)
      } else {
        throw new Error('Unable to delete this Intro')
      }
    })
}

export default {
  getIntroTexts,
  createIntroText,
  deleteIntroText,
  getIntroTextById,
  updateIntroText,
}
